import { bikeLabelOrderSlice } from "features/bikeLabelOrder/slice/bikeLabelOrderSlice"
import { bikeFleetSlice } from "../features/bikeFleet/slice/bikeFleetSlice"

export const rootReducer = {
	bikeFleet: bikeFleetSlice.reducer,
	bikeLabelOrder: bikeLabelOrderSlice.reducer,
}
